import React from 'react';
/**
 * DjayAvatar part — tier flair (pro band / master crown + cape).
 * Verbatim extraction of the former `renderTierElements()`. The `uid` keeps
 * gradient ids unique across simultaneously-rendered avatars.
 */
import type { DjayTier } from '../types';
interface TierElementsProps {
  tier: DjayTier;
  uid: string;
  showDetails: boolean;
}
export function TierElements({
  tier,
  uid,
  showDetails
}: TierElementsProps) {
  if (!showDetails) return null;
  switch (tier) {
    case 'pro':
      return <g className="djay-tier-pro" data-id="element-3509" data-mp="3k3ewmczwf5m7">
          <path d="M45 75 Q100 85 155 75 L150 65 Q100 75 50 65 Z" fill="#3B82F6" data-id="element-3510" data-mp="3k4ghtaamp8hn" />
          
          <path d="M45 75 Q100 85 155 75 L150 65 Q100 75 50 65 Z" fill={`url(#${uid}-pro-band-grad)`} opacity="0.5" data-id="element-3511" data-mp="3fb5al81wmpp7" />
          
          <path d="M145 70 L165 60 L160 75 Z" fill="#2563EB" data-id="element-3512" data-mp="bnv63lqm41au" />
          <defs data-id="element-3513" data-mp="bpfzh816xe74">
            <linearGradient id={`${uid}-pro-band-grad`} x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-3514" data-mp="bpy87451hkvx">
              
              <stop offset="0%" stopColor="#1D4ED8" data-id="element-3515" data-mp="6vbu2t7kpe85" />
              <stop offset="50%" stopColor="#60A5FA" data-id="element-3516" data-mp="3lz59mrxbwhgf" />
              <stop offset="100%" stopColor="#1D4ED8" data-id="element-3517" data-mp="3qx7223gn9t4k" />
            </linearGradient>
          </defs>
        </g>;
    case 'master':
      return <g className="djay-tier-master" data-id="element-3518" data-mp="3c799lbbomh9k">
          <path d="M60 55 L70 25 L85 45 L100 15 L115 45 L130 25 L140 55 Z" fill="#FBBF24" stroke="#D97706" strokeWidth="2" strokeLinejoin="round" data-id="element-3519" data-mp="3c66l1a1u0qwt" />
          
          <circle cx="70" cy="25" r="4" fill="#EF4444" data-id="element-3520" data-mp="336jgifdt34zj" />
          <circle cx="100" cy="15" r="5" fill="#3B82F6" data-id="element-3521" data-mp="3797qwri64jym" />
          <circle cx="130" cy="25" r="4" fill="#10B981" data-id="element-3522" data-mp="37ar8clfk911z" />
          <path d="M65 50 Q100 60 135 50" fill="none" stroke="#D97706" strokeWidth="2" data-id="element-3523" data-mp="2t9oma8okfqr2" />
          
          <path d="M40 120 Q20 150 30 190 L60 180 Q45 140 50 120 Z" fill="#7C3AED" data-id="element-3524" data-mp="2y7ztebnh7n5l" />
          
          <path d="M160 120 Q180 150 170 190 L140 180 Q155 140 150 120 Z" fill="#7C3AED" data-id="element-3525" data-mp="ribi5luf9mw2" />
          
          <path d="M45 125 Q100 145 155 125 L150 115 Q100 135 50 115 Z" fill="#6D28D9" data-id="element-3526" data-mp="whoecx76o6bb" />
          
        </g>;
    default:
      return null;
  }
}